import bezier from 'bezier-easing'

const marketingHeroConfig = {
  texts: [['YOUR', 'ODOMETER'], ['MEASURE THE JOURNEY']],
  duration: 5000,
  bezier: bezier(0.42, 0, 0.58, 1)
}

export { marketingHeroConfig }
